var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86557 25.7616V27.9998M24.1375 25.7616V27.9998M25.5928 25.0155H7.41151C6.60823 25.0155 5.95703 24.3474 5.95703 23.5233V18.3007C5.95703 16.6524 7.25942 15.3163 8.86599 15.3163H24.1383C25.745 15.3163 27.0473 16.6524 27.0473 18.3007V23.5233C27.0473 24.3474 26.3961 25.0155 25.5928 25.0155ZM11.411 20.1659C11.411 20.5779 11.0854 20.912 10.6838 20.912C10.2821 20.912 9.95651 20.5779 9.95651 20.1659C9.95651 19.754 10.2821 19.4199 10.6838 19.4199C11.0854 19.4199 11.411 19.754 11.411 20.1659ZM23.0471 20.1659C23.0471 20.5779 22.7214 20.912 22.3198 20.912C21.9182 20.912 21.5926 20.5779 21.5926 20.1659C21.5926 19.754 21.9182 19.4199 22.3198 19.4199C22.7214 19.4199 23.0471 19.754 23.0471 20.1659ZM25.5923 15.3163H7.41098L8.46034 8.85701C8.69412 7.418 9.9077 6.36328 11.3297 6.36328H21.6736C23.0957 6.36328 24.3091 7.418 24.543 8.85701L25.5923 15.3163Z",
    stroke: "#353A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0467 19.7269C27.8469 19.655 34.6875 19.1876 34.6173 18.3666L34.1728 13.1639C34.0324 11.522 32.6213 10.3077 31.0209 10.4516L24.5655 10.8177M32.4693 10.3214L30.8741 3.98074C30.5187 2.56818 29.22 1.62622 27.8034 1.75363L17.499 2.68041C16.0824 2.80782 14.9633 3.96724 14.8529 5.4217M31.6791 19.2584L32.0997 23.0868M30.3466 15.3805C30.3817 15.7909 30.0857 16.1529 29.6856 16.1889C29.2856 16.2249 28.9327 15.9212 28.8977 15.5108C28.8626 15.1004 29.1586 14.7384 29.5586 14.7024C29.9587 14.6664 30.3115 14.9701 30.3466 15.3805Z",
    stroke: "#353A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5937 16.2924C6.97395 16.2924 1.68591 16.4031 1.68591 15.7834L1.68591 11.8559C1.68591 10.6164 2.69067 9.61167 3.93017 9.61167L8.26638 9.70957M2.80845 9.6117L3.61796 4.75421C3.7984 3.67206 4.73459 2.87891 5.8317 2.87891L13.812 2.87891C14.9091 2.87891 15.1868 3.71041 15.3671 4.79256M3.93084 16.25L3.93084 19.1498M4.77209 13.2586C4.77209 13.5685 5.02333 13.8197 5.33315 13.8197C5.64297 13.8197 5.89422 13.5685 5.89422 13.2586C5.89422 12.9488 5.64297 12.6976 5.33315 12.6976C5.02333 12.6976 4.77209 12.9488 4.77209 13.2586Z",
    stroke: "#353A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongestion);
export default __webpack_public_path__ + "static/media/Congestion.87f1502ecd9126edba47e6cd7cae0af9.svg";
export { ForwardRef as ReactComponent };